import React, {useState, useEffect} from 'react';

import MobileMenuItem from './mobilemenuitem';

import {useMobileMenu} from './state';

const {withNoProps} = polyphony.hoc;
const {useRefWithListeners, useResize, useA11yButton} = polyphony.hooks;
const {prefixCSS} = polyphony.css;
const {scrolling} = polyphony.dom;

const styles = {
    opener: prefixCSS({
        padding: '0px 20px',
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        cursor: 'pointer',
        pointerEvents: 'auto'
    }),
    children: prefixCSS({
        zIndex: 1000,
        position: 'absolute',
        left: 0,
        transition: 'height .5s ease-in-out, background-color 0.5s ease-in-out',
        width: "100%",
        boxSizing: 'border-box'
    })
};

const svgs = {
    hamburger: <svg aria-hidden='true' height="32px" width="32px" viewBox="0 0 448 512"><path fill="currentColor" d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z" /></svg>
};

// TODO: https://www.w3.org/TR/wai-aria-practices/examples/treeview/treeview-2/treeview-2b.html

const MobileMenu = withNoProps(() => {
    const screenHeight = useResize().height;
    const {
        isColor,
        headerHeight,
        setOpen: _setOpen, isOpen,
        items
    } = useMobileMenu();

    const setOpen = o => {
        _setOpen(o);
        if (o) scrolling.disable();
        else   scrolling.enable();
    };

    // Ensure the header bar behaves normally when
    // the breakpoint switches from "mobile" to anything else.
    useEffect(() => () => setOpen(false), []);

    let [showScroller, setShowScroller] = useState(false);

    const ref = useRefWithListeners({
        transitionend: () => setShowScroller(true),
        transitionstart: () => setShowScroller(false)
    }, [isOpen, showScroller]);

    const [{hover, active}, bref] = useA11yButton();

    return (
        <>
            <a onClick={() => setOpen(!isOpen)} ref={bref} aria-haspopup="true" aria-controls="SICMobileMenu"
                 style={{...styles.opener, color: active || hover ? "#0F3762" : isColor ? 'gray' : 'white'}}>
                {svgs.hamburger}
            </a>

            <ul role='tree'
                tabIndex='-1'
                ref={ref}
                id="SICMobilemenu"
                style={{...styles.children,
                        paddingTop: isOpen ? 15 : undefined,
                        paddingBottom: isOpen ? 15 : undefined,
                        backgroundColor: isColor || isOpen ? 'white' : 'transparent',
                        top: headerHeight,
                        height: isOpen ? screenHeight - headerHeight : '0px',
                        overflowY: showScroller ? 'auto' : 'hidden'}}>
                {items.map((i, idx) => <MobileMenuItem item={i} key={i.id} number={idx} setsize={items.length} />)}
            </ul>
        </>
    );
});

MobileMenu.displayName = 'MobileMenu';

export default MobileMenu;

